// extracted by mini-css-extract-plugin
module.exports =  {"footer":"_02712f2b3b--footer--jtM2H","logo":"_02712f2b3b--logo--IFSuE","description":"_02712f2b3b--description--Qv3SJ","button":"_02712f2b3b--button--YvH4l"};